import { render, staticRenderFns } from "./companyApproval.vue?vue&type=template&id=2a64b715&scoped=true"
import script from "./companyApproval.vue?vue&type=script&lang=js"
export * from "./companyApproval.vue?vue&type=script&lang=js"
import style0 from "./companyApproval.vue?vue&type=style&index=0&id=2a64b715&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64b715",
  null
  
)

export default component.exports